import { Field, formValueSelector, reduxForm } from 'redux-form'

import WrappedRadio from 'components/Shared/Forms/WrappedRadio'
import { connect } from 'react-redux'
import Button from '../Shared/Button'
import WizardFooter from './WizardFooter'
import { FORM_NAME } from './shared'

type WizardFormGoalPageProps = {
  handleSubmit: () => void
}

type FormValues = {
  independent: true | false | null
  established: true | false | null
}

const WizardFormGoalPage = (
  props: WizardFormGoalPageProps & FormValues
): JSX.Element => {
  const { handleSubmit, independent, established } = props

  return (
    <>
      <form
        id="new-app-goal-form"
        className="new-app-form"
        onSubmit={handleSubmit}
      >
        <div className="new-app-goal-settings">
          <div className="new-app-goal-label">
            What are you looking to achieve with Adalo?
          </div>
          <Field
            className="new-app-hiring-option"
            component={WrappedRadio}
            styled
            name="independent"
            radioValue
            label="I want to build an app myself"
          />
          <Field
            className="new-app-hiring-option"
            component={WrappedRadio}
            styled
            name="independent"
            radioValue={false}
            label="I want to hire someone to build it for me"
          />
          {independent === false && (
            <>
              <div className="new-app-goal-label">
                Do you have an established business?
              </div>

              <Field
                className="new-app-hiring-option"
                component={WrappedRadio}
                styled
                name="established"
                radioValue
                label="Yes"
              />
              <Field
                className="new-app-hiring-option"
                component={WrappedRadio}
                styled
                name="established"
                radioValue={false}
                label="No"
              />
            </>
          )}
        </div>
      </form>
      <WizardFooter>
        <Button
          className="next align-right"
          type="submit"
          disabled={
            independent === null ||
            (independent === false && established === null)
          }
          form="new-app-goal-form"
          data-adalo-id="new-app-goal-form-next"
        >
          Next
        </Button>
      </WizardFooter>
    </>
  )
}

function mapStateToProps(state: Record<string, unknown>) {
  const selector = formValueSelector(FORM_NAME)
  const independentValue: unknown = selector(state, 'independent')
  const establishedValue: unknown = selector(state, 'established')

  return {
    independent:
      typeof independentValue === 'boolean' ? independentValue : null,
    established:
      typeof establishedValue === 'boolean' ? establishedValue : null,
  }
}

export default reduxForm<FormValues, WizardFormGoalPageProps>({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(connect(mapStateToProps)(WizardFormGoalPage))
